export const LangChainIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="#1F8771"
        fillRule="evenodd"
        d="M6.2 3.5a3.2 3.2 0 0 1 4.2-.3l.5.5a.75.75 0 0 0 1.06-1.06l-.5-.5a4.7 4.7 0 0 0-6.17.45 4.7 4.7 0 0 0 0 6.64l1.8 1.8a.75.75 0 1 0 1.06-1.06l-1.8-1.8a3.2 3.2 0 0 1 0-4.52zm3.6 8.4a3.2 3.2 0 0 1-4.2.3l-.5-.5a.75.75 0 0 0-1.06 1.06l.5.5a4.7 4.7 0 0 0 6.17-.45 4.7 4.7 0 0 0 0-6.64l-1.8-1.8a.75.75 0 1 0-1.06 1.06l1.8 1.8a3.2 3.2 0 0 1 0 4.52z"
        clipRule="evenodd"
      />
    </svg>
  );
};
